// extracted by mini-css-extract-plugin
export default {"tileContainer":"NOHEfficiencySummaryTile_tileContainer__mZs8v"};